import React from "react";

import {
  convertDateToUTC,
  convertEpochTo12HourTime,
} from "../../../../../shared";
import EventDetailRow from "../../../../../shared/components/Events/EventDetailRow";

const EventRequestDetail = ({ event, handleAccept, handleDecline }) => {
  const ianaTimezone = event?.eventLocation?.[0]?.timezone;
  return (
    <div>
      <EventDetailRow label="event type:" value={event?.eventType?.name} />
      <EventDetailRow
        label="event date:"
        value={convertDateToUTC(event?.eventDate, ianaTimezone)}
      />
      <EventDetailRow
        label="event duration:"
        value={`${event?.duration} ${
          event?.duration <= 1 ? " hour" : " hours"
        }`}
      />
      <EventDetailRow
        label="event start time:"
        value={convertEpochTo12HourTime(event?.eventStartTime, ianaTimezone)}
      />
      <EventDetailRow
        label="shutterb start time:"
        value={convertEpochTo12HourTime(event?.sbStartTime, ianaTimezone)}
      />
      <EventDetailRow
        label="address"
        value={event?.eventLocation[0]?.currentLocation}
      />
      <div className="d-flex justify-content-start g-3 py-2 px-3">
        <button
          type="button"
          className="btn-accpet"
          onClick={() => {
            handleAccept(
              event.id,
              event?.orderItemId,
              event?.user?.userName,
              "true",
              ""
            );
          }}
        >
          accept
        </button>
        <button
          type="button"
          className="btn-decline"
          onClick={() => {
            handleDecline(event);
          }}
        >
          decline
        </button>
      </div>
    </div>
  );
};

export default EventRequestDetail;
